import { render } from "./HeartIcon.vue?vue&type=template&id=978d3e0e"
import script from "./HeartIcon.vue?vue&type=script&lang=js"
export * from "./HeartIcon.vue?vue&type=script&lang=js"

import exportComponent from "/Users/kakkote/Mediadeski/2022-01-aluevaalit-kompassianalyysi/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__